'use strict'
import Vue from 'vue'
import { Modal } from 'ant-design-vue'

const Confirm = {
	install: function (Vue, options) {
		Vue.$confirm = Modal.confirm
		Vue.prototype.$confirm = Modal.confirm
	},
}

Vue.use(Modal)

export default Confirm
